import { render } from "./LoaderSpinner.vue?vue&type=template&id=e01eac36"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=e01eac36&lang=css"
script.render = render

export default script